import React from 'react';
import Footer from '../components/shared/Footer';
import Navigation from '../components/shared/Navigation';

const Layout = ({ children }) => {
    return (
        <div className=''>
            <Navigation />
            <div className='md:overflow-auto overflow-hidden'>
                {children}
            </div>
            <Footer/>
        </div>
    );
};

export default Layout;